/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorBlocksStatsRequest
 */
export interface ValidatorBlocksStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatorBlocksStatsRequest
     */
    address: string;
}

export function ValidatorBlocksStatsRequestFromJSON(json: any): ValidatorBlocksStatsRequest {
    return ValidatorBlocksStatsRequestFromJSONTyped(json, false);
}

export function ValidatorBlocksStatsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorBlocksStatsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
    };
}

export function ValidatorBlocksStatsRequestToJSON(value?: ValidatorBlocksStatsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
    };
}


